module.exports = __webpack_public_path__ + "img/txt.61514e41.png";